import * as React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  AppBar,
} from "@mui/material";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import SelectLanguageMenuButton from "../i18n/SelectLanguageMenuButton";
import { FlexEmpty } from "../Utility/FlexEmpty";
import AuthCheckLoading from "../Utility/Route/AuthCheckLoading";

import TranslateWrapper from "../i18n/TranslateWrapper";
import CenterBox from "../Utility/CenterBox";
import { LogoButton } from "./LogoButton";
import SignInButton from "./SignInButton";
import dynamic from "next/dynamic";
import { auth } from "../Firebase/SDK/firebaseAuth";
import { NineSolsIcon } from "../Utility/Icons/NinesolsIcon";
// import AdminCheck from "../Admin/AdminCheck";

const AdminCheck = dynamic(() => import("../Admin/AdminCheck"), {
  ssr: false,
});
export default function MobileNav() {
  const { t } = useTranslation("myaccount");
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen((o) => !o);
  };

  const handleSignOut = async () => {
    await auth.signOut();
    window.location.reload();
  };
  return (
    <TranslateWrapper ns="myaccount">
      <AppBar position="fixed">
        <Toolbar>
          <IconButton
            onClick={toggleDrawer}
            edge="start"
            color="inherit"
            aria-label="menu"
            size="large"
          >
            <MenuIcon />
          </IconButton>
          <FlexEmpty></FlexEmpty>
          <SelectLanguageMenuButton></SelectLanguageMenuButton>
          {/* <LinkButton variant="contained" color="primary" to="/mytrades">
          查詢訂單
        </LinkButton> */}

          {/* </AuthCheck> */}
        </Toolbar>

        <CenterBox
          style={{
            pointerEvents: "none",
            top: 0,
            position: "fixed",
            width: "100%",
            height: 56,
          }}
        >
          <div style={{ pointerEvents: "all" }}>
            <LogoButton></LogoButton>
          </div>
        </CenterBox>
      </AppBar>
      <Drawer anchor="top" open={open} onClose={toggleDrawer}>
        <List>
          <Link href="/">
            <ListItem button onClick={toggleDrawer}>
              {/* {t()} */}
              {t("nav-store-front")}
            </ListItem>
          </Link>
          {/* <Link href="/event/shanhai9000">
           <ListItem button onClick={toggleDrawer}>
             {"N҈̨̲̩͎̓͐̽͠ï̴̡̛͈͆͊n҉̨̮̪̲͆̑̕ę̶͚̭͌̓̑͝S̶̢̥͉҇͑ő̶̦̉͜͠l҈̨͕̜̯̓̎̕ş̷̫҇̂͒̄"}
           </ListItem>
         </Link> */}
          {/* <Link href="/projects/ninesols">
            <ListItem button onClick={toggleDrawer}>
              <NineSolsIcon
                style={{
                  height: 18,
                  width: 18,
                  paddingBottom: 0,
                  // paddingRight: 4,
                }}
              ></NineSolsIcon>
              {t("nav-nine-sols")}
            </ListItem>
          </Link>
          <hr></hr> */}
          <Link href="/library">
            <ListItem button onClick={toggleDrawer}>
              {/* {t()} */}
              {t("nav-my-library")}
            </ListItem>
          </Link>
          <hr></hr>
          <Link href="/account">
            <ListItem button onClick={toggleDrawer}>
              {t("my-account-button")}
            </ListItem>
          </Link>
          <Link href="/account/history">
            <ListItem button onClick={toggleDrawer}>
              {t("puchase-history")}
            </ListItem>
          </Link>

          <AuthCheckLoading
            fallback={
              <SignInButton onClick={toggleDrawer}>
                {t("nav-login")}
              </SignInButton>
            }
          >
            <ListItem
              button
              onClick={() => {
                handleSignOut();
                toggleDrawer();
              }}
            >
              {t("logout-button")}
            </ListItem>
            <AdminCheck fallback={null}>
              <Link href="/admin">
                <ListItem button onClick={toggleDrawer}>
                  {"管理員"}
                </ListItem>
              </Link>
            </AdminCheck>
          </AuthCheckLoading>
        </List>
      </Drawer>
    </TranslateWrapper>
  );
}
// type ListItemLink = {to:string} & ListItemProps
// function ListItemLink(props: ListItemLink) {
//   return (
//     <ListItem component={Link as any} to={props.to} {...props}>
//       {props.children}
//     </ListItem>
//   );
// }
